import { Achievement, Campaign, GroupCampaign } from '@/models/reward';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgRewardsExtras',
})
export default class CmgRewardsExtras extends Vue {
  async mounted() {
    const countryCode = this.$appStore.state.ui.countryProfile.countryCode;
    const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();

    if (!isLoggedIn) {
      if( countryCode === 'GB' ) {
        window.location.replace(`${window.location.origin}/offers`);  
      } else {
        window.location.replace(`${window.location.origin}${this.$services.config.getRewardsPath()}`);
      }
      return;
    }

    if (isLoggedIn && !this.isEnrolledInLoyalty && this.isLoyaltyEligible) {
      window.location.replace(`${window.location.origin}${this.$services.config.getRewardsPath()}`);
      return;
    }

    if (!this.isLoyaltyEligible) {
      this.$router.replace({ name: Routes.Rewards });
      return;
    }

    this.setLoadingStatus(true);
    Promise.all([this.$services.reward.getExtrasCampaigns(), this.$services.reward.getExtrasAchievements()])
      .finally(() => this.setLoadingStatus(false));
  }

  get isCustomerStudent(): boolean {
    return this.$appStore.getters.isActiveStudent;
  }

  get isEnrolledInLoyalty(): boolean {
    return this.$services.loyalty.isEnrolledInLoyalty(this.$appStore.state.customer.profile);
  }  

  get isLoyaltyEligible(): boolean {
    return this.$services.loyalty.isLoyaltyEligible(this.$appStore.state.customer.profile);
  }

  get achievements(): Achievement[] {
    return this.$appStore.state.reward.achievements;
  }

  get campaigns(): Campaign[] {
    return this.$appStore.state.reward.campaigns;
  }

  get groupCampaigns(): GroupCampaign[] {
    return this.$appStore.state.reward.groupCampaigns;
  }

  setLoadingStatus(loading: boolean) {
    this.$services.ui.setAppBlur(loading);
    this.$services.ui.setAppPepperVisibility(loading);
  }
}
